<template>
  <NuxtLayout name="default">
    <template #menu>
      <quiz-editor-block-menu />
    </template>
    <quiz-editor-quiz-content />
  </NuxtLayout>
</template>

<script lang="ts">
import { provide } from "vue"

import { useQuizEditorStore } from "~/stores/quizEditorStore"
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    const userStore = useUserStore()
    const quizEditorStore = useQuizEditorStore()

    provide("editorStore", quizEditorStore)

    definePageMeta({
      layout: false,
    })

    return { userStore, quizEditorStore }
  },

  computed: {
    hasValidRole(): boolean {
      return ["admin", "content_admin", "content_creator", "field_leader"].includes(
        this.userStore.current?.role
      )
    },
  },

  created() {
    if (!this.hasValidRole) {
      navigateTo("/")
      return
    }

    const subjectId = Number(this.$route.query.subject_id)
    const gradeId = Number(this.$route.query.grade_id)

    if (!subjectId || !gradeId) {
      navigateTo("/")
      return
    }

    this.quizEditorStore.initNewQuiz(subjectId, gradeId)
  },

  mounted() {
    window.hideBeacon()
  },

  beforeUnmount() {
    window.unhideBeacon()
  },
}
</script>
